// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dairy Logo Modal (DLM) styling — follows the ARM modal conventions */

.dlm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: dlmFadeIn 0.25s ease-out;
  padding: 16px;
}

.dlm-modal-container {
  background: #ffffff;
  border-radius: 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
  border: 1px solid rgba(241, 245, 249, 0.8);
  overflow: hidden;
  animation: dlmScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: flex;
  flex-direction: column;
}

@keyframes dlmFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes dlmScaleIn {
  from { transform: scale(0.95) translateY(15px); opacity: 0; }
  to { transform: scale(1) translateY(0); opacity: 1; }
}

.dlm-modal-header {
  padding: 24px 28px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
}

.dlm-modal-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.dlm-modal-close-btn {
  background: #f1f5f9;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
}

.dlm-modal-close-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.dlm-modal-body {
  padding: 20px 28px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

/* Feedback banner */
.dlm-feedback-banner {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.dlm-feedback-banner.success {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.dlm-feedback-banner.error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.dlm-feedback-icon {
  flex-shrink: 0;
}

/* Logo preview */
.dlm-logo-preview-area {
  width: 160px;
  height: 160px;
  border-radius: 16px;
  background: #f8fafc;
  border: 2px dashed #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.dlm-logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #ffffff;
}

.dlm-logo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  padding: 12px;
}

.dlm-logo-placeholder-icon {
  font-size: 2.2rem;
}

.dlm-logo-loading {
  color: #94a3b8;
  font-size: 2rem;
}

/* Dairy name caption */
.dlm-dairy-name-caption {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.dlm-caption-icon {
  color: #64748b;
  font-size: 13px;
}

/* Actions */
.dlm-actions-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
}

.dlm-upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #0d47a1 0%, #2563eb 100%);
  border: none;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.25);
}

.dlm-upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.3);
}

.dlm-upload-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.dlm-remove-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dlm-remove-btn:hover {
  background: #fee2e2;
}

.dlm-remove-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dlm-hidden-file-input {
  display: none;
}

/* Hint */
.dlm-hint-box {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 12px 14px;
  background: #f8fafc;
  border-radius: 12px;
  font-size: 12.5px;
  color: #64748b;
  line-height: 1.5;
}

.dlm-hint-icon {
  color: #0d47a1;
  flex-shrink: 0;
  margin-top: 1px;
}

/* Mobile */
@media (max-width: 480px) {
  .dlm-modal-header {
    padding: 20px 20px 14px;
  }

  .dlm-modal-body {
    padding: 16px 20px 20px;
  }

  .dlm-actions-row {
    flex-direction: column;
  }

  .dlm-upload-btn,
  .dlm-remove-btn {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DairyLogoModal.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,oDAAoD;EACpD,0CAA0C;EAC1C,gBAAgB;EAChB,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Dairy Logo Modal (DLM) styling — follows the ARM modal conventions */\n\n.dlm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: dlmFadeIn 0.25s ease-out;\n  padding: 16px;\n}\n\n.dlm-modal-container {\n  background: #ffffff;\n  border-radius: 24px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);\n  border: 1px solid rgba(241, 245, 249, 0.8);\n  overflow: hidden;\n  animation: dlmScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  display: flex;\n  flex-direction: column;\n}\n\n@keyframes dlmFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes dlmScaleIn {\n  from { transform: scale(0.95) translateY(15px); opacity: 0; }\n  to { transform: scale(1) translateY(0); opacity: 1; }\n}\n\n.dlm-modal-header {\n  padding: 24px 28px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.dlm-modal-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.dlm-modal-close-btn {\n  background: #f1f5f9;\n  border: none;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: all 0.2s ease;\n}\n\n.dlm-modal-close-btn:hover {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.dlm-modal-body {\n  padding: 20px 28px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Feedback banner */\n.dlm-feedback-banner {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.dlm-feedback-banner.success {\n  background: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.dlm-feedback-banner.error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.dlm-feedback-icon {\n  flex-shrink: 0;\n}\n\n/* Logo preview */\n.dlm-logo-preview-area {\n  width: 160px;\n  height: 160px;\n  border-radius: 16px;\n  background: #f8fafc;\n  border: 2px dashed #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.dlm-logo-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #ffffff;\n}\n\n.dlm-logo-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #94a3b8;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: center;\n  padding: 12px;\n}\n\n.dlm-logo-placeholder-icon {\n  font-size: 2.2rem;\n}\n\n.dlm-logo-loading {\n  color: #94a3b8;\n  font-size: 2rem;\n}\n\n/* Dairy name caption */\n.dlm-dairy-name-caption {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.dlm-caption-icon {\n  color: #64748b;\n  font-size: 13px;\n}\n\n/* Actions */\n.dlm-actions-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.dlm-upload-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #0d47a1 0%, #2563eb 100%);\n  border: none;\n  color: #ffffff;\n  padding: 10px 20px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.25);\n}\n\n.dlm-upload-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.3);\n}\n\n.dlm-upload-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.dlm-remove-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  padding: 10px 20px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dlm-remove-btn:hover {\n  background: #fee2e2;\n}\n\n.dlm-remove-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.dlm-hidden-file-input {\n  display: none;\n}\n\n/* Hint */\n.dlm-hint-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 14px;\n  background: #f8fafc;\n  border-radius: 12px;\n  font-size: 12.5px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.dlm-hint-icon {\n  color: #0d47a1;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Mobile */\n@media (max-width: 480px) {\n  .dlm-modal-header {\n    padding: 20px 20px 14px;\n  }\n\n  .dlm-modal-body {\n    padding: 16px 20px 20px;\n  }\n\n  .dlm-actions-row {\n    flex-direction: column;\n  }\n\n  .dlm-upload-btn,\n  .dlm-remove-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
